import { defineStore } from 'pinia';

interface NotificationState {
  isLoading: boolean;
}

export const useNotificationStore = defineStore('notification', {
  state: (): NotificationState => ({
    isLoading: true,
  }),
  actions: {
    setLoading(value: boolean) {
      this.isLoading = value;
    },
  },
});
